class BerlinPackageModal {
  constructor() {
    this.modal = document.getElementById('BerlinPackageModal');
    if (!this.modal) return;

    this.form = this.modal.querySelector('#BerlinPackageForm');
    this.contactInput = this.modal.querySelector('[data-berlin-contact]');
    this.emailInput = this.modal.querySelector('[data-berlin-email-hidden]');
    this.bodyInput = this.modal.querySelector('[data-berlin-body]');
    this.errorEl = this.modal.querySelector('[data-berlin-error]');
    this.formWrap = this.modal.querySelector('[data-berlin-form-wrap]');
    this.successEl = this.modal.querySelector('[data-berlin-success]');

    this.fallbackEmail = this.modal.dataset.fallbackEmail || 'hello@bamboopacks.com';

    this.bindTriggers();
    this.bindClose();
    this.bindForm();
  }

  bindTriggers() {
    document.querySelectorAll('[data-berlin-modal-open]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });
  }

  bindClose() {
    this.modal.querySelectorAll('[data-berlin-modal-close]').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('is-open')) {
        this.close();
      }
    });
  }

  bindForm() {
    if (!this.form) return;

    this.form.addEventListener('submit', (e) => {
      if (!this.validateAndPrepare()) {
        e.preventDefault();
      }
    });
  }

  isEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  validateAndPrepare() {
    if (!this.contactInput || !this.emailInput || !this.bodyInput) return true;

    const contact = this.contactInput.value.trim();
    const name = this.form.querySelector('[name="contact[name]"]')?.value.trim();
    const restaurant = this.form.querySelector('[name="contact[Restaurant]"]')?.value.trim();

    if (!name || !contact || !restaurant) {
      this.showError(this.modal.dataset.errorText || 'Please fill in all required fields.');
      return false;
    }

    this.hideError();

    const packageLine = this.bodyInput.dataset.packageLine || '';
    const bodyLines = ['[Berlin Gratis-Paket]', `Paket: ${packageLine}`];

    if (this.isEmail(contact)) {
      this.emailInput.value = contact;
      bodyLines.push(`Kontakt: ${contact}`);
    } else {
      const handle = contact.startsWith('@') ? contact : `@${contact.replace(/^@/, '')}`;
      this.emailInput.value = this.fallbackEmail;
      bodyLines.push(`Instagram: ${handle}`);
    }

    bodyLines.push(`Restaurant: ${restaurant}`);
    bodyLines.push(`Kontaktperson: ${name}`);
    this.bodyInput.value = bodyLines.join('\n');

    return true;
  }

  showError(msg) {
    if (this.errorEl) {
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
    }
  }

  hideError() {
    if (this.errorEl) this.errorEl.hidden = true;
  }

  open() {
    this.modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    if (window.location.hash !== '#berlin-package') {
      history.replaceState(null, '', '#berlin-package');
    }
  }

  close() {
    this.modal.classList.remove('is-open');
    document.body.style.overflow = '';

    if (window.location.hash === '#berlin-package') {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }

  checkHash() {
    if (window.location.hash === '#berlin-package') {
      this.open();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const instance = new BerlinPackageModal();
  instance.checkHash();
  window.addEventListener('hashchange', () => instance.checkHash());

  if (window.location.search.includes('contact_posted=true')) {
    const modal = document.getElementById('BerlinPackageModal');
    if (modal) {
      modal.classList.add('is-open');
      const formWrap = modal.querySelector('[data-berlin-form-wrap]');
      const successEl = modal.querySelector('[data-berlin-success]');
      if (formWrap) formWrap.hidden = true;
      if (successEl) successEl.hidden = false;
    }
  }
});
